import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Save } from "lucide-react";
import { API } from "@/lib/config";

const FIELDS = [
  { key: "hero_eyebrow", label: "Homepage Hero — Eyebrow", placeholder: "Where Confidence Meets Life Readiness" },
  { key: "hero_title", label: "Homepage Hero — Title", placeholder: "Where Confidence Meets Life Readiness" },
  { key: "hero_tagline", label: "Homepage Hero — Tagline", placeholder: "The Confidence to Thrive. The Skills to Lead." },
  { key: "hero_paragraph", label: "Homepage Hero — Paragraph", type: "textarea", placeholder: "Every girl deserves to know her worth…" },
  { key: "contact_email", label: "Contact Email", placeholder: "info@shesagirlsgirl.org" },
  { key: "contact_phone", label: "Contact Phone", placeholder: "980.406.5940" },
  { key: "contact_address", label: "Contact Location", placeholder: "Charlotte, North Carolina" },
];

const SiteSettings = () => {
  const [data, setData] = useState({});
  const [saving, setSaving] = useState(false);

  const load = async () => {
    try {
      const res = await axios.get(`${API}/cms-settings`);
      setData(res.data || {});
    } catch { toast.error("Failed to load settings"); }
  };
  useEffect(() => { load(); }, []);

  const save = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/cms-settings`, data);
      toast.success("Homepage & contact info saved.");
      load();
    } catch { toast.error("Save failed"); }
    finally { setSaving(false); }
  };

  const inputCls = "w-full bg-white border border-[#E5E5E5] rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#E94F9A]/30";

  return (
    <div className="space-y-5" data-testid="site-settings">
      <div>
        <h4 className="font-serif text-lg font-bold text-[#4B1E5A]">Homepage Text & Contact Info</h4>
        <p className="font-sans text-xs text-[#4A4A4A]">Leave a field blank to use the site's default wording. Changes appear on the live site immediately.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {FIELDS.map((f) => (
          <div key={f.key} className={f.type === "textarea" ? "md:col-span-2" : ""}>
            <label className="text-[11px] font-semibold text-[#4A4A4A] uppercase tracking-wider">{f.label}</label>
            {f.type === "textarea" ? (
              <textarea rows={3} value={data[f.key] || ""} onChange={(e) => setData({ ...data, [f.key]: e.target.value })} data-testid={`settings-${f.key}`} className={inputCls} placeholder={f.placeholder} />
            ) : (
              <input value={data[f.key] || ""} onChange={(e) => setData({ ...data, [f.key]: e.target.value })} data-testid={`settings-${f.key}`} className={inputCls} placeholder={f.placeholder} />
            )}
          </div>
        ))}
      </div>
      <button onClick={save} disabled={saving} data-testid="site-settings-save" className="inline-flex items-center gap-2 bg-[#4B1E5A] text-white rounded-full px-7 py-3 text-sm font-semibold hover:bg-[#E94F9A] disabled:opacity-60">
        <Save className="h-4 w-4" /> {saving ? "Saving…" : "Save Settings"}
      </button>
    </div>
  );
};

export default SiteSettings;
